import { render, staticRenderFns } from "./ModalExportarShapeAreasRecompor.vue?vue&type=template&id=597e0d5b&lang=pug"
import script from "./ModalExportarShapeAreasRecompor.vue?vue&type=script&lang=js"
export * from "./ModalExportarShapeAreasRecompor.vue?vue&type=script&lang=js"
import style0 from "./ModalExportarShapeAreasRecompor.vue?vue&type=style&index=0&id=597e0d5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports